
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import Btn from "../common/Btn";
import { IAchievement } from "../../data";
import { useInView } from "../../hooks";
import { i18nManager } from "../../i18n";
import TrophyCard from "../common/TrophyCard";
import SectionHeader from "../common/SectionHeader";
import styles from "../../assets/style.module.css";
import { IProfileWebsite } from "../../../../../services";
import { activeMedia, pagePath } from "../../helpers";

export interface TrophiesProps {
    basePath: string;
    website: IProfileWebsite;
    achievements: IAchievement[];
}

function Trophies({ website, basePath, achievements }: TrophiesProps) {

    const [ref, inView] = useInView();
    const labels = i18nManager.Labels.home;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const image = activeMedia(website, "PASSPORT") ?? activeMedia(website, "HALF_BODY");

    if (!achievements.length) return null;

    return (<section className={Classname.build(styles["section"], styles["bg-grey"])}>
        <div className={Classname.build(styles["container"], styles["trophies"])} style={image ? undefined : { gridTemplateColumns: "1fr" }}>
            {image && (<div className={styles["trophies-img"]}>
                <img src={image} alt={website.display_name} />
            </div>)}
            <div ref={ref}>
                <SectionHeader kicker={labels.achievements_kicker} title={labels.achievements_title} titleEm={labels.achievements_title_em} />
                <div className={styles["trophy-grid"]}>
                    {achievements.map((a, i) => (<TrophyCard key={a.title} achievement={a} index={i} visible={inView} />))}
                </div>
                <Btn variant="dark" to={{ pathname: pagePath(basePath, "ACHIEVEMENTS"), search: searchParams.toString() }}>{labels.view_achievements}</Btn>
            </div>
        </div>
    </section>);
}

export default Trophies;
